import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build";

export interface CKeditorProps {
  data: any;
  handleOnChange: (e: any, editor: any) => void;
}

const CKeditor: React.FC<CKeditorProps> = ({ data, handleOnChange }: any) => {
  return (
    <CKEditor
      editor={Editor}
      config={Editor.defaultConfig}
      data={data}
      onChange={(event: any, editor: any) => {
        handleOnChange(event, editor);
      }}
      onFocus={(event: any, editor: any) => {
        handleOnChange(event, editor);
      }}
    />
  );
};

export default CKeditor;
